"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromEmpty = void 0;
const fp_1 = require("lodash/fp");
const monet_1 = require("monet");
const ts_pattern_1 = require("ts-pattern");
function fromEmpty(data) {
    return (0, ts_pattern_1.match)(data)
        .when(fp_1.isString, x => x === '' ? (0, monet_1.None)() : (0, monet_1.Just)(x))
        .when(fp_1.isNumber, x => (0, fp_1.isNaN)(x) ? (0, monet_1.None)() : (0, monet_1.Just)(x))
        .when(fp_1.isObject, x => (0, fp_1.isEmpty)(x) ? (0, monet_1.None)() : (0, monet_1.Just)(x))
        .otherwise((0, fp_1.always)((0, monet_1.None)()));
}
exports.fromEmpty = fromEmpty;
//# sourceMappingURL=fromEmpty.js.map